import { render, staticRenderFns } from "./OnboardingSuccess.vue?vue&type=template&id=2203925b&scoped=true&"
import script from "./OnboardingSuccess.vue?vue&type=script&lang=js&"
export * from "./OnboardingSuccess.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSuccess.vue?vue&type=style&index=0&id=2203925b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2203925b",
  null
  
)

export default component.exports